import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Packages from "./sections/Packages";
import Process from "./sections/Process";
import Detailing from "./sections/Detailing";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Packages />
      
      <Detailing />
      <Footer />
    </div>;
}